
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(5 10)"}},[_c('path',{attrs:{"d":"M23.99 7.462C25.177 3.056 29.128 0 33.638 0h22.724c4.51 0 8.461 3.056 9.648 7.462L67 11.14H23l.99-3.677z"}}),_c('path',{attrs:{"d":"M0 25.316C0 19.724 4.477 15.19 10 15.19h70c5.523 0 10 4.534 10 10.126v44.557C90 75.466 85.523 80 80 80H10C4.477 80 0 75.466 0 69.873V25.316zm62 22.279c0 9.508-7.611 17.215-17 17.215s-17-7.707-17-17.215S35.611 30.38 45 30.38s17 7.707 17 17.215zM80.5 30.38c3.038 0 5.5-2.494 5.5-5.57s-2.462-5.57-5.5-5.57-5.5 2.494-5.5 5.57 2.462 5.57 5.5 5.57z","fill-rule":"evenodd"}}),_c('ellipse',{attrs:{"cx":"45","cy":"47.595","rx":"12","ry":"12.152"}})])])
          )
        }
      }
    